import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { ModalService } from 'asksuite-citrus';
import { CreditsBalanceService } from '@core/services/credits-balance.service';
import { LoggerService } from '@core/services/logger.service';
import { LogEvent } from '@core/enums/log-event';
import { CreditsBalanceModalComponent } from '../components/credits-balance-modal/credits-balance-modal.component';
import { CreditsBalanceModalV2Component } from '../components/credits-balance-modal-v2/credits-balance-modal-v2.component';

export type CreditsModalOrigin = 'pill' | 'banner' | 'footer';

/** Opens the WhatsApp credits modal, v1 or v2 depending on `enable_whatsapp_credits_v2`. */
@Injectable({ providedIn: 'root' })
export class CreditsModalLauncherService {
  constructor(
    private creditsBalanceService: CreditsBalanceService,
    private modalService: ModalService,
    private logger: LoggerService
  ) {}

  open(origin: CreditsModalOrigin): void {
    this.creditsBalanceService.v2Enabled$.pipe(take(1)).subscribe((v2) => {
      if (!v2) {
        this.modalService.open(CreditsBalanceModalComponent, { maxWidth: 620 });
        return;
      }

      this.modalService.open(CreditsBalanceModalV2Component, { maxWidth: 643 });
      this.logger.log(LogEvent.LIVECHAT_CREDITS_MODAL_V2_OPEN, { origin });
    });
  }
}
